// eslint-disable-next-line
import { FC, memo, useEffect, useRef } from 'react';
// Hooks
import { usePlayBox100000 } from 'hooks/organisms/playBox/usePlayBox100000';
// Components
import PlayBoxWrap from 'components/organisms/top/playBox/PlayBoxWrap';
// Recoil
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { playBoxShowState } from 'store/atoms/playBoxShowState';
// Utils
import { PLAYBOX_ID, PLAYBOX_TYPE } from 'utils/const/playBox';
// Images
import dayLottsIcon from 'assets/images/top/playBox/daylotts100000_icon.svg';

// id
const { ID_100000 } = PLAYBOX_ID;

/**
 *
 * Component
 *
 */
const PlayBox100000: FC = memo(() => {
  // Recoil
  // PLAYBOX開閉情報更新関数
  const setPlayBoxShow = useSetRecoilState(playBoxShowState);
  // playbox開閉状態
  const playBoxShow = useRecoilValue(playBoxShowState);

  // このコンポーネントのplaybox情報
  const { initialBoxId, isShow100000 } = playBoxShow;
  // PLAYBOX用カスタムフック(個別)
  const { scrollToBox, onClickShow } = usePlayBox100000();

  const boxRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // モーダルメニューからの遷移
    if (initialBoxId === ID_100000) {
      setPlayBoxShow({
        initialBoxId: playBoxShow.initialBoxId,
        isShow1000: false,
        isShow5000: false,
        isShow10000: false,
        isShow100000: true,
        isShow1000000: false,
      });

      window.setTimeout(() => {
        // スクロール
        scrollToBox(boxRef);
      }, 500);
    }
  }, [initialBoxId]);

  return (
    <PlayBoxWrap
      type={PLAYBOX_TYPE.BOX_100000}
      id={ID_100000}
      isShow={isShow100000}
      icon={dayLottsIcon}
      _ref={boxRef}
      onClickMethod={onClickShow}
    />
  );
});
export default PlayBox100000;
